import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";

const MAX_VIEWS_PER_DAY = 2;
const VIEW_COUNTS_STORAGE_KEY_POSTFIX = "-manage-contacts-modal-view-counts";

/**
 * Detects when automatically show manage contacts modal
 */
const useShowManageContactsModal = () => {
  const { getAdsBackground } = useContent();
  const { getContactList, getUserData } = useUser();

  const getTodaysViewCounts = () => {
    // get value from local storage
    const currentDate = new Date().toDateString();
    const viewCounts = localStorage.getItem(
      currentDate + VIEW_COUNTS_STORAGE_KEY_POSTFIX
    );

    return viewCounts ? parseInt(viewCounts) : 0;
  };

  const incTodaysViewCounts = () => {
    // set value to local storage
    const currentDate = new Date().toDateString();
    const viewCounts = getTodaysViewCounts() + 1;
    localStorage.setItem(
      currentDate + VIEW_COUNTS_STORAGE_KEY_POSTFIX,
      viewCounts + ""
    );
  };

  const getLastClosingTime = () => {
    // get value from local storage
    return localStorage.getItem("last-closing-time" + getUserData()?.UserName);
  };

  const setLastClosingTime = () => {
    // set value to local storage
    localStorage.setItem(
      "last-closing-time" + getUserData()?.UserName,
      new Date().toISOString()
    );
  };

  const isClosingTimeMoreThenOneDay = () => {
    const lastClosingTime = getLastClosingTime();
    if (!lastClosingTime) return true;

    const lastClosingDate = new Date(lastClosingTime);
    const currentDate = new Date();

    return currentDate.getDate() - lastClosingDate.getDate() > 1;
  };
  const isViewCountsMoreThenTwo = getTodaysViewCounts() >= MAX_VIEWS_PER_DAY;
  const isAdCampaignActive = !!getAdsBackground()?.adId;
  const isUserHaveContactsSet = !!getContactList()?.length;

  const shouldShowManageContactsModal =
    isClosingTimeMoreThenOneDay() &&
    !isViewCountsMoreThenTwo &&
    !isAdCampaignActive &&
    !isUserHaveContactsSet;

  return {
    shouldShowManageContactsModal,
    setLastClosingTime,
    incTodaysViewCounts,
  };
};

export default useShowManageContactsModal;
